import React, { useEffect, useState } from 'react';
import Column from '@sdk/components/ui/spacing/Column';
import H3 from '@sdk/components/ui/typography/H3';
import { AutomatedBreakType } from '@sdk/settings/types';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { useDispatch } from 'react-redux';

import RadioButton from '@kiosk/common/components/ui/RadioButton/RadioButton';
import Button from '@kiosk/common/components/Button';
import ButtonContainer from '@kiosk/common/components/Forms/ButtonContainer';
import AnimatedRow from '@kiosk/common/components/Forms/AnimatedRow';
import FormScreenContainer from '@kiosk/common/components/ui/FormScreenContainer';
import { useAutomatedBreaksContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedBreaksProvider/AutomatedBreaksProvider';
import { getDefaultBreakTypeSelection } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/SelectAutomatedBreakView/selectAutomatedBreakView.utils';
import { setHideGreeting } from '@kiosk/timeClock/actions';
import {
  AUTOMATED_TYPE_FIELD_NAME,
  DELAY
} from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/SelectAutomatedBreakView/selectAutomatedBreakView.constants';

const SelectAutomatedBreakView = () => {
  const dispatch = useDispatch();
  const {
    startAutomatedBreak,
    canTakeMealBreak,
    canTakeRestBreak,
    setAutomatedBreakScreen
  } = useAutomatedBreaksContext();

  const defaultBreakTypeSelection = getDefaultBreakTypeSelection({
    canTakeMealBreak,
    canTakeRestBreak
  });

  const [automatedBreakType, setAutomatedBreakType] = useState<AutomatedBreakType>(
    defaultBreakTypeSelection
  );
  const isStartBreakButtonActive = !!automatedBreakType;

  useEffect(() => {
    dispatch(setHideGreeting(true));

    return () => {
      dispatch(setHideGreeting(false));
    };
  }, []);

  return (
    <FormScreenContainer>
      <AnimatedRow noPaddingHorizontal delay={DELAY}>
        <H3 themeColor={ThemeColorType.primaryText} bold>
          Select break
        </H3>
      </AnimatedRow>

      <Column
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.name === AUTOMATED_TYPE_FIELD_NAME) {
            setAutomatedBreakType((e.target.value as any) as AutomatedBreakType);
          }
        }}>
        {canTakeMealBreak && (
          <AnimatedRow borderTop noPaddingHorizontal delay={DELAY}>
            <RadioButton
              fieldName={AUTOMATED_TYPE_FIELD_NAME}
              label={'Meal break'}
              value={AutomatedBreakType.meal}
              checked={automatedBreakType === AutomatedBreakType.meal}
            />
          </AnimatedRow>
        )}
        {canTakeRestBreak && (
          <AnimatedRow borderBottom borderTop noPaddingHorizontal delay={DELAY}>
            <RadioButton
              fieldName={AUTOMATED_TYPE_FIELD_NAME}
              label={'Rest break'}
              value={AutomatedBreakType.rest}
              checked={automatedBreakType === AutomatedBreakType.rest}
            />
          </AnimatedRow>
        )}
      </Column>

      <ButtonContainer delay={0.4}>
        <Button
          disabled={!isStartBreakButtonActive}
          label="Start break"
          buttonTheme={isStartBreakButtonActive ? 'grey' : 'disabled'}
          themeColor={isStartBreakButtonActive ? 'btnBreakTextColor' : 'whiteText'}
          onPress={() => startAutomatedBreak(automatedBreakType)}
        />
        <Button
          label="Cancel"
          buttonTheme="grey"
          onPress={() => setAutomatedBreakScreen('clockedIn')}
          withMargin
        />
      </ButtonContainer>
    </FormScreenContainer>
  );
};

export default SelectAutomatedBreakView;
